<template>
  <!-- 最外层wrap div  start-->
  <div class="wrap_Box">
    <!-- {{formData}} -->
    <!-- 里面版心 box start -->
    <div class="innerBox">
      <!--form 表单区域 start  -->
      <div class="formBox">
        <form action class="NumberForm" @submit.prevent>
          <!-- 输入框 box start  -->
          <div class="inputBox">
            <!-- 手机号码输入框盒子 -->
            <div class="phoneBox input-div">
              <!-- 手机号码输入框 -->
              <input
                type="text"
                name="phoneNumber"
                class="phoneNumber phoneBox_item"
                placeholder="请输入手机号"
                :maxlength="11"
                v-model="formData.phoneNumber"
              />
              <div class="phoneImg InputImg_item">
                <img src="../assets/image/bindAcount/phone.png" alt />
              </div>
            </div>
            <div class="imgVerificationBox input-div">
              <input
                type="text"
                name="Verification"
                class="Verification phoneBox_item"
                placeholder="请输入图片中的数字"
                v-model="formData.ImgVerification"
              />
              <div class="VerificationCodeImg InputImg_item">
                <img src="../assets/image/bindAcount/VerificationCode.png" alt />
              </div>
              <div class="VerificationBox">
                <!-- <img :src="ImgVerificationSrc" alt=""> -->
                <!-- <image :src="ImgVerificationSrc"> -->
                <!-- var date=new Date();
                img1.src=图片地址+"?"+date.toLocaleString();-->
                <img
                  class="tabImgVerificatio"
                  v-if="VerificationFlag"
                  :key="num"
                  :src="ImgVerificationSrc"
                  @click="tabImgVerification"
                />
              </div>
            </div>
            <!-- 验证码输入框盒子 -->
            <div class="Verification_CodeBox input-div">
              <!-- 验证码输入框 -->
              <input
                type="text"
                name="Verification_Code"
                class="VerificationCode phoneBox_item"
                placeholder="请输入手机验证码"
                v-model="formData.VerificationCode"
              />
              <div class="VerificationCodeImg InputImg_item">
                <img src="../assets/image/bindAcount/VerificationCode.png" alt />
              </div>
              <button
                ref="sendCodeRefs"
                class="send_Verification_Code"
                :disabled="disabledSendCode"
                @click="sendVerificationCode"
              >{{SendCodeBtnContext}}</button>
            </div>
          </div>
          <!-- 输入框 box end  -->
          <!-- 按钮 box start -->
          <div class="submitBtn_box custom-footer-box">
            <!-- 按钮 container -->
            <div class="summitBtn_container">
              <!-- &nbsp  &nbsp相当于空格 -->
              <button class="sbumitBtn" @click=" completebindAcount">
                完
                成
              </button>
            </div>
          </div>
          <!-- 按钮 box end -->
        </form>
      </div>
      <!--form 表单区域 end  -->
    </div>
    <!-- 里面版心 box end -->
  </div>
  <!-- 最外层wrap div  end-->
</template>
<script>
import { getApi, postApi } from '../api/index.js'
import { setTimeout, clearInterval } from 'timers'
import {AppIdName,TokenName,jxAppId} from '../api/api.js';

export default {
  data() {
    return {
      formData: {
        phoneNumber: '',
        VerificationCode: '',
        ImgVerification: ''
      },
      // 图形验证码
      ImgVerificationSrc:'',
      // 控制点击图片刷新
      num: 0,
      // 控制切换图片
      VerificationFlag: true,
      // 倒计时
      TimeCountdown: 0,
      // 控制获取验证码按钮
      sendImgVerificationIsShow: true,
      // 控制60秒倒计时的按钮
      TimeCountdownIsShow: false,
      // 控制按钮禁用状态
      disabledSendCode: false,
      // 按钮内容
      SendCodeBtnContext: '获取短信验证码',
      isFrom: 1,
      lifeToken: '',
	  smsToken:'',
	  appId:'',
    }
  },
  created: function() {	
	this.appId = localStorage.getItem(AppIdName);
	this.smsToken = this.guid();
	//console.log("smsToken==>"+this.smsToken);
	this.lifeToken = localStorage.getItem(TokenName+this.appId || "");	
    this.isFrom = this.$route.query.isFrom;
    this.ImgVerificationSrc='https://zg.lifejiankang.com/api/validate/kaptcha.jpg?userCode=' +this.smsToken;
  },
  methods: {
    //发送验证码点击事件
    sendImgVerification() {
      this.TimeCountdown = 60
      this.disabledSendCode = true
      this.Timer()
    },
	guid() {
	   return this.appId+"_"+Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36);
	},
    Timer() {
      if (this.TimeCountdown > 0) {
        this.TimeCountdown--;
        this.$refs.sendCodeRefs.className = 'Countdown_Code'
        this.SendCodeBtnContext = this.TimeCountdown + 's后重新获取验证码'
        setTimeout(this.Timer, 1000)
      } else {
        this.$refs.sendCodeRefs.className = 'send_Verification_Code'
        this.TimeCountdown = 0
        this.SendCodeBtnContext = '重新获取验证码'
        this.disabledSendCode = false
      }
    },
    //  切换图形验证码；
    tabImgVerification() {
      this.num++
      let date = new Date().toLocaleString()
      this.ImgVerificationSrc = `https://zg.lifejiankang.com/api/validate/kaptcha.jpg?userCode=${this.smsToken}&time=${date}`
    },
    // 获取验证码?
    sendVerificationCode() {
      let phonereg = /^[1][1,2,3,4,5,7,8,9][0-9]{9}$/
      if (
        this.formData.phoneNumber.length <= 0 &&
        this.formData.phoneNumber.length > 11
      ) {
        this.$toast('请输入11位手机号码')
        return
      } else if (!phonereg.test(this.formData.phoneNumber)) {
        this.$toast('请输入正确手机号码')
        return
      } else if (this.formData.ImgVerification.length != 4) {
        this.$toast('请输入四位图像验证码')
        return
      }

      // /sms/send/{mobile}/{validateCode}/{userCode}
      getApi({
        url: `/sms/send/${this.formData.phoneNumber}/${this.formData.ImgVerification}/${this.smsToken}`
      })
        .then(res => {
          console.log(res)
          if (res.resCode == '0') {
            this.sendImgVerification()
            this.$toast('短信验证码发送成功')
          } else if (res.resCode == '-1') {
            this.formData.ImgVerification = ''
            this.num++
            let date = new Date().toLocaleString()
            this.ImgVerificationSrc = `https://zg.lifejiankang.com/api/validate/kaptcha.jpg?userCode=${this.smsToken}&time=${date}`
            this.$toast(res.resMsg || '四位验证码输入错误')
          }
        })
        .catch(res => {
          console.log(res)
          console.log('发送失败')
        })
    },
    //  完成
    completebindAcount() {
      let phonereg = /^[1][1,2,3,4,5,7,8,9][0-9]{9}$/
      if (
        this.formData.phoneNumber.length <= 0 &&
        this.formData.phoneNumber.length > 11
      ) {
        this.$toast('请输入11位手机号码')
        return
      } else if (!phonereg.test(this.formData.phoneNumber)) {
        this.$toast('请输入正确手机号码')
        return
      } else if (this.formData.ImgVerification.length != 4) {
        this.$toast('请输入四位图像验证码')
        return
      }
      else if(this.formData.VerificationCode.length!=4){
         this.$toast('请输入四位短信验证码')
        return
      }
	  
      postApi({
        url: `/member/register`,
        query: {
          memberPhone: this.formData.phoneNumber,
          smsCode: this.formData.VerificationCode,
          memberName: this.$route.query.memberName,
          memberCardType: this.$route.query.memberCardType,
          memberCardNo: this.$route.query.memberCardNo,
          recommender: this.$route.query.recommender,
          memberSex: this.$route.query.sexCode,
		  memberBirthday:this.$route.query.birthDate,
		  appId:this.appId,
        }
      })
        .then(res => {
		  this.tabImgVerification();
          if (res.resCode == '0') {            
			localStorage.setItem(TokenName+this.appId, res.data.accessToken);
			this.$toast('注册成功')
            setTimeout(() => {
              this.$router.push(
                {
                  path: '/home'
                },
                2000
              )})
          } else if (res.resCode == '-1'){
            console.log(res);
            this.$toast(res.resMsg || '您已经是注册会员，请登录');
          }
        })
        .catch(res => {
          console.log('网络连接失败')
        })
    }
  }
}
</script>
 <style lang="less" scoped>
@import '../common/css/style.css';
// 最外层div
.wrap_Box {
  width: 100%;
  height: 100%;
  // 里面内容部分
  .innerBox {
    box-sizing: border-box;
    height: 1.91rem;
    width: 100%;
    height: 100%;
    background-color: #eff3f4;
    box-sizing: border-box;
  }
}
// 表单盒子
.formBox {
  box-sizing: border-box;
  width: 100%;
  // 所有输入框的父盒子
  .inputBox {
    box-sizing: border-box;

    .imgVerificationBox {
      position: relative;
      //  border-bottom: 0.01rem solid rgb(238, 238, 238);
      .VerificationBox {
        position: absolute;
        top: 0.16rem;
        left: 5.7rem;
      }
    }

    // 输入框中图片
    .InputImg_item {
      position: absolute;
      top: 0.22rem;
      left: 0.38rem;
      img {
        width: 0.28rem;
        height: 0.32rem;
      }
    }

    width: 100%;
    .input-div {
      border-bottom: 0.02rem solid rgb(238, 238, 238);
      height: 0.95rem;
      margin-top: 0.02rem;
    }
    // 全部输入框 box
    .phoneBox_item {
      padding-left: 0.78rem;
      position: relative;
      box-sizing: border-box;
      letter-spacing: -0.006rem;
      width: 100%;
      font-size: 0.24rem;
      color: rgb(153, 153, 153);
      height: 0.95rem;
      background-color: #ffffff;
      border: 0px solid transparent;
    }
    // 验证码输入框 box
    .Verification_CodeBox {
// margin-bottom: 0.01rem;
      //  border-bottom: 0.01rem solid rgb(238, 238, 238);
      position: relative;
      // 发送验证码按钮
      .send_Verification_Code {
        height: 0.6rem;
        width: 2.5rem;
        background: transparent;
        border: 0px solid transparent;
        border-radius: 0.215rem;
        background-color: rgb(77, 205, 112);
        color: rgb(255, 255, 255);
        font-size: 0.23rem;
        text-align: center;
        line-height: 0.25rem;
        position: absolute;
        top: 0.15rem;
        left: 4.8rem;
        letter-spacing: -0.6px;
        padding: 0.11rem 0.16rem 0.11rem 0.16rem;
      }
      .Countdown_Code {
        height: 0.6rem;
        background-color: #eeeeee;
        color: rgb(255, 255, 255);
        width: 2.8rem;
        font-size: 0.23rem;
        border: 0px solid transparent;
        border-radius: 0.215rem;
        text-align: center;
        line-height: 0.25rem;
        position: absolute;
        top: 0.13rem;
        left: 4.5rem;
        letter-spacing: -0.6px;
        padding: 0.11rem 0.16rem 0.11rem 0.16rem;
      }
    }
  }

  // 按钮盒子
  .submitBtn_box {
    height: 1.22rem;
    width: 100%;
    .summitBtn_container {
      margin: 0 auto;
      width: 4.8rem;
      height: 0.88rem;
      margin: 0.16rem auto;
    }

    .sbumitBtn {
      width: 100%;
      height: 100%;
      background-color: rgb(77, 205, 112);
      text-align: center;
      line-height: 100%;
      border: 1px solid transparent;
      border-radius: 0.2rem;
      font-size: 0.3rem;
      color: #fdfefd;
    }
  }
}
</style>
